import jwtAuthAxios from "../../services/jwtAuth";
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';


export const getSoal = createAsyncThunk("cbt/getSoal", async() => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get('/v1/cbt/soal');
    return response.data;
});

// retry helper untuk koneksi buruk: ulangi beberapa kali dengan jeda bertambah
const fetchWithRetry = async (fn, retries = 4, baseDelayMs = 1500) => {
    let lastErr;
    for (let attempt = 0; attempt <= retries; attempt++) {
        try {
            return await fn();
        } catch (e) {
            lastErr = e;
            if (attempt < retries) {
                await new Promise((r) => setTimeout(r, baseDelayMs * (attempt + 1)));
            }
        }
    }
    throw lastErr;
};

// metadata ringan untuk mulai ujian (cbtId, waktu, jumlah soal)
export const getSoalInit = createAsyncThunk("cbt/getSoalInit", async() => {
    const token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await fetchWithRetry(() => jwtAuthAxios.get('/v1/cbt/soal/init', { timeout: 30000 }));
    return response.data;
});

// ambil soal per halaman (chunk) untuk cbtId yang sama
export const getSoalPage = createAsyncThunk("cbt/getSoalPage", async({ cbtId, page, size }) => {
    const token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await fetchWithRetry(() => jwtAuthAxios.get(
        `/v1/cbt/soal/page?cbtId=${cbtId}&page=${page}&size=${size}`, { timeout: 30000 }
    ));
    return response.data;
});

export const getCbtInfo = createAsyncThunk("cbt/getCbtInfo", async() => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get('/v1/pmb/cbt');
    return response.data;
});

export const saveHasilCbt = createAsyncThunk("cbt/saveHasilCbt", async(payload) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post('v1/cbt/soal',payload);
    return response.data;
});

export const createSoalManual = createAsyncThunk("cbt/createSoalManuak", async(payload) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post('/v1/cbt-akses/create',payload);
    return response.data;
});

export const getMasterCbt = createAsyncThunk("masterCbt/getAll", async(id) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/cbt-akses/${id}`);
    return response.data;
});

export const getHasilUjian = createAsyncThunk("masterCbt/getHasilUjian", async() => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/view/cbt/hasil/user/all`);
    return response.data;
});


const initialState = {
    loading: false,
    loadingInit: false,
    listSoal: [],
    hasilCbt: [],
    cbtInfo:[],
    updatedData: [],
    dataCreateSoal: [],
    dataAllMaster:[],
    loadingHasilUjian:false,
    dataHasilUjian:[]
}


const cbtSlice = createSlice({
    name:"cbt",
    initialState: initialState,
    reducers:{
        addAnswerTest:(state, action) => {
            const existingIndex = state.updatedData.findIndex(item => item.questionId === action.payload.questionId);
            if (existingIndex !== -1) {
                state.updatedData[existingIndex] = action.payload;
            } else {
                state.updatedData.push(action.payload);
            }
        },
        clearDataAnswer:(state) => {
            state.updatedData= []
        },
        // set/replace listSoal (dipakai untuk restore dari cache & merge chunk)
        restoreListSoal:(state, action) => {
            state.listSoal = action.payload;
        }
    },
    extraReducers: (builder) => {
    builder
        .addCase(getSoal.pending, (state) => {
            state.loading = true;
        })
        .addCase(getSoal.fulfilled, (state, action) => {
            state.listSoal = action.payload;
            state.loading = false;
        })
        .addCase(getSoal.rejected, (state, action) => {
            state.loading = false;
            console.error("Error during getMatkul:", action.error);
        })
    builder
        .addCase(getSoalInit.pending, (state) => {
            state.loadingInit = true;
        })
        .addCase(getSoalInit.fulfilled, (state) => {
            state.loadingInit = false;
        })
        .addCase(getSoalInit.rejected, (state) => {
            state.loadingInit = false;
        })
    builder
        .addCase(getCbtInfo.pending, (state) => {
            state.loading = true;
        })
        .addCase(getCbtInfo.fulfilled, (state, action) => {
            state.cbtInfo = action.payload;
            state.loading = false;
        })
        .addCase(getCbtInfo.rejected, (state, action) => {
            state.loading = false;
            console.error("Error during getMatkul:", action.error);
        })
    builder
        .addCase(saveHasilCbt.pending, (state) => {
            state.loading = true;
        })
        .addCase(saveHasilCbt.fulfilled, (state, action) => {
            state.hasilCbt = action.payload;
            state.loading = false;
        })
        .addCase(saveHasilCbt.rejected, (state, action) => {
            state.loading = false;
            console.error("Error during getMatkul:", action.error);
        })
    builder
        .addCase(createSoalManual.pending, (state) => {
            state.loading = true;
        })
        .addCase(createSoalManual.fulfilled, (state, action) => {
            state.dataCreateSoal = action.payload;
            state.loading = false;
        })
        .addCase(createSoalManual.rejected, (state, action) => {
            state.loading = false;
            console.error("Error during getMatkul:", action.error);
        })
    builder
        .addCase(getMasterCbt.pending, (state) => {
            state.loading = true;
        })
        .addCase(getMasterCbt.fulfilled, (state, action) => {
            state.dataAllMaster = action.payload;
            state.loading = false;
        })
        .addCase(getMasterCbt.rejected, (state, action) => {
            state.loading = false;
            console.error("Error during getMatkul:", action.error);
        })
    builder
        .addCase(getHasilUjian.pending, (state) => {
            state.loadingHasilUjian = true;
        })
        .addCase(getHasilUjian.fulfilled, (state, action) => {
            state.dataHasilUjian = action.payload;
            state.loadingHasilUjian = false;
        })
        .addCase(getHasilUjian.rejected, (state, action) => {
            state.loadingHasilUjian = false;
            console.error("Error during getMatkul:", action.error);
        })
    }
})
export const cbtSelector = (state) => state.cbt;
export default cbtSlice.reducer;
export const { addAnswerTest, clearDataAnswer, restoreListSoal } = cbtSlice.actions;